"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateListMonths = void 0;
const datePart_1 = require("./datePart");
const dateTimeFormat_1 = require("./dateTimeFormat");
const numberFormatPad_1 = require("./numberFormatPad");
/**
 * Zwraca tablicę zawierającą listę miesięcy pomiędzy datami
 * @param startDate data początkowa
 * @param endDate data końcowa
 * @param format format, domyślnie MMMM yyyy, czyli "styczeń 2019"
 */
function dateListMonths(startDate, endDate, format /* = 'MMMM yyyy'*/) {
    let m1 = (0, datePart_1.datePart)(startDate, 'M') - 1;
    let y1 = (0, datePart_1.datePart)(startDate, 'y');
    const m2 = (0, datePart_1.datePart)(endDate, 'M') - 1;
    const y2 = (0, datePart_1.datePart)(endDate, 'y');
    const result = [];
    let func;
    switch (format) {
        case 'MMMM yyyy':
            func = (m, y) => dateTimeFormat_1.monthNames[m] + ' ' + y;
            break;
        case 'MMM yyyy':
            func = (m, y) => dateTimeFormat_1.monthShort[m] + ' ' + y;
            break;
        case 'MM yyyy':
            func = (m, y) => (0, numberFormatPad_1.numberFormatPad)(m + 1) + ' ' + y;
            break;
        case 'M yyyy':
            func = (m, y) => m + 1 + ' ' + y;
            break;
        case 'MMMM':
            func = (m) => dateTimeFormat_1.monthNames[m];
            break;
        case 'MMM':
            func = (m) => dateTimeFormat_1.monthShort[m];
            break;
        case 'MM':
            func = (m) => (0, numberFormatPad_1.numberFormatPad)(m + 1);
            break;
        case 'M':
            func = (m) => (m + 1).toString();
            break;
        default:
            func = (m, y) => dateTimeFormat_1.monthNames[m] + ' ' + y;
            break;
    }
    while ((m1 <= m2 && y1 === y2) || y1 < y2) {
        result.push(func(m1, y1));
        m1++;
        if (m1 > 11) {
            m1 = 0;
            y1++;
        }
    }
    return result;
}
exports.dateListMonths = dateListMonths;
//# sourceMappingURL=dateListMonths.js.map